<template>
    <div class="main-bg">
      <el-button
        size="mini"
        type="primary"
        @click="handleAdd">新增</el-button>
      <div class="container">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="appName"
            align="center"
            label="应用名称">
          </el-table-column>
          <el-table-column
            prop="appType"
            align="center"
            label="应用类型">
            <template slot-scope="scope">
              {{scope.row.appType==1?'Android':'ios'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceType"
            align="center"
            label="设备类型">
            <template slot-scope="scope">
              {{scope.row.deviceType==1?'app':'ipad'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="appVersion"
            align="center"
            label="设备版本号">
          </el-table-column>
          <el-table-column
            prop="isForce"
            align="center"
            label="是否强制更新">
            <template slot-scope="scope">
              {{scope.row.paymentState==1?'强制':'不强制'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="appUrl"
            align="center"
            label="下载地址">
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="上传时间">
            <template slot-scope="scope">
              <p>{{timestampToTime(scope.row.createTime)}}</p>
            </template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="status"-->
            <!--label="操作"-->
            <!--width="200"-->
            <!--fixed="right"-->
            <!--align="center">-->
            <!--<template slot-scope="scope">-->
              <!--<el-button-->
                <!--size="mini"-->
                <!--type="primary"-->
                <!--v-if="scope.row.balanceStatus!=1101"-->
                <!--@click="handleDetail(scope.row)">查看</el-button>-->
            <!--</template>-->
          <!--</el-table-column>-->
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          style="float: right;margin-top: 20px;"
          :page-size="10"
          background
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
      <!--新增弹窗-->
      <el-dialog title="新增"  :visible.sync="addFlag" width="80%" append-to-body class="my-label">
        <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="应用名称" prop="appName">
                <el-input disabled v-model="ruleForm.appName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应用类型" prop="appType">
                <el-select v-model="ruleForm.appType" disabled placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in appType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备类型" prop="deviceType">
                <el-select v-model="ruleForm.deviceType" disabled placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in deviceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备版本号" prop="appVersion">
                <el-input  v-model="ruleForm.appVersion"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否强制更新" prop="isForce">
                <el-select v-model="ruleForm.isForce" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in isForce"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--<el-col :span="12">-->
              <!--<el-form-item label="升级提示" prop="upgradePoint">-->
                <!--<el-input  v-model="ruleForm.upgradePoint"></el-input>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
            <el-col :span="24">
              <el-form-item label="安装包" prop="appUrl">
                <el-upload
                  class="upload-demo"
                  action="https://dogs.zhuanqianpa.cn/dogs_dev/oss/getEditionLogUrl"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleAvatarSuccess"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传apk文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="更新日志" prop="updateLog">
                <vue-editor v-model="ruleForm.updateLog" />
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: right">
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
              <el-button @click="addFlag=false">取 消</el-button>
            </el-form-item>
          </div>

        </el-form>
      </el-dialog>

    </div>
</template>

<script>
  import {getDogsEditionListPage,saveDogsEdition } from '@/api/edition'
  import { VueEditor } from "vue2-editor";
    export default {
        name: "edition",
      components: { VueEditor },
      data(){
          return{
            pageNum:1,
            tableData:[],
            total:0,
            rules:{
              appName: [
                { required: true, message: '请输入应用名称', trigger: 'blur' }
              ],
              appType: [
                { required: true, message: '请选择应用类型', trigger: 'change' }
              ],
              deviceType: [
                { required: true, message: '请选择设备类型', trigger: 'change' }
              ],
              appVersion: [
                { required: true, message: '请输入设备版本号', trigger: 'blur' }
              ],
              isForce: [
                { required: true, message: '请选择是否强制更新', trigger: 'change' }
              ],
              // appUrl: [
              //   { required: true, message: '请上传安装包', trigger: 'change' }
              // ],
              updateLog: [
                { required: true, message: '请输入更新日志', trigger: 'blur' }
              ],

            },
            fileList:[],
            appType:[{
                value: 1,
                label: 'Android'
              }, {
                value: 2,
                label: 'ios'
              }],
            deviceType:[{
              value: 1,
              label: 'app'
            }, {
              value: 2,
              label: 'ipad'
            }],
            isForce:[{
              value: 1,
              label: '强制'
            }, {
              value: 2,
              label: '不强制'
            }],
            ruleForm:{
              appName:'菜狗app',
              appType:1,
              deviceType:1,
            },
            addFlag:false,
          }
      },
      mounted(){
          this.getList()
      },
      methods:{
        beforeAvatarUpload(file) {
          console.log(file.type)
          const isJPG = file.type === 'application/vnd.android.package-archive'


          if (!isJPG) {
            this.$message.error('上传文件只能是 apk 格式!');
          }

          return isJPG ;
        },
        handleAvatarSuccess(res, file) {
          this.ruleForm.appUrl = res.body
          console.log(this.fileList)

        },
        handleExceed(files, fileList) {
          this.$message.error(`最多只能上传一个文件！`);
        },
        handleAdd(){
          this.addFlag=true
        },
        submitForm(formName) {
          this.$refs[formName].validate(async (valid) => {
            if (valid) {
              let body={
                ...this.ruleForm
              }
              let res=await saveDogsEdition({body})
              if (res.code=='2000'){
                this.$message.success('上传成功')
                this.getList()
                this.addFlag=false
              }else{
                this.$message.error(res.msg)
              }
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
          async getList(){
            let body={
              "pageSize": 10, //每页条数
              "pageNum": this.pageNum, //当前页
              table:{}
            }
            let res = await getDogsEditionListPage({body})
            this.tableData=res.body.list
            this.total=res.body.totalCount
          },
        handleDetail(){

        },
        handleCurrentChange(val){
          this.pageNum=val
          this.getList()
        },
        timestampToTime(timestamp) {
          var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
          var Y = date.getFullYear() + '-';
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
          var D = date.getDate() + ' ';
          return Y+M+D;
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/edition.vue